export default __webpack_public_path__ + "static/media/Paypal-Business-Model.2a58a593.jpeg";